import { Flights } from "@/lib/Types/Flight";

export function getMinBaggageAllowance(
  flights: Flights | undefined | null
): { minBags: number | null; minWeight: number | null } | null {
  if (!flights) return null;

  const allFlights = [
    ...(flights.outwardFlight ?? []),
    ...(flights.returnFlight ?? []),
  ];

  if (allFlights.length === 0) return null;

  const min = allFlights.reduce((acc, f) =>
    (f.maxWeight ?? Infinity) < (acc.maxWeight ?? Infinity) ? f : acc
  );

  if (min.maxWeight || min.maxBags) {
    return { minWeight: min.maxWeight ?? null, minBags: min.maxBags ?? null };
  }

  return null;
}
